//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpButton from '../button/Button.vue';

export default {
  name: 'DpOptionGroup',
  components: { DpButton },
  props: {
    title: { type: String, default: null },
    buttonsEnabled: { type: Boolean, default: true },
    emptyText: { type: String, default: null },
  },
  methods: {
    create() {
      this.$emit('create');
    },
    manage() {
      this.$emit('manage');
    },
  },
};
